"use strict";

exports.__esModule = true;
exports.Config = void 0;
const Config = exports.Config = {
  make: ({
    livePreview = Config.makeLivePreview()
  } = {}) => ({
    livePreview
  }),
  makeLivePreview: ({
    enabled = false,
    updatedComponentIds = [],
    dataIsInvalidated = false
  } = {}) => ({
    enabled,
    updatedComponentIds,
    dataIsInvalidated
  }),
  isLivePreviewEnabled: config => config.livePreview.enabled,
  filterConnectionsByUpdatedComponents: (config, connections) => {
    const {
      livePreview: {
        enabled,
        updatedComponentIds
      }
    } = config;
    const updatedComponents = new Set(updatedComponentIds);
    const connectionsToUpdatedComponents = enabled && updatedComponentIds.length ? connections.filter(connection => updatedComponents.has(connection.compId)) : connections;
    return connectionsToUpdatedComponents;
  }
};
//# sourceMappingURL=config.js.map